// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["light-dark-mode/style-index"], () => (__webpack_require__("./src/light-dark-mode/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
